import { useSearchParams } from "react-router-dom";
import {
  FaTimes,
  FaArrowLeft,
  FaPhone,
  FaEnvelope,
  FaExclamationTriangle,
  FaRedo,
} from "react-icons/fa";
import SmallClouds from "../../components/utils/SmallClouds";
import {
  PageWrapper,
  Container,
  FailureContainer,
  FailureIcon,
  FailureTitle,
  FailureSubtitle,
  ErrorMessage,
  OrderNumber,
  InfoGrid,
  InfoBox,
  InfoHeader,
  InfoTitle,
  InfoText,
  ButtonGroup,
  RetryButton,
  BackButton,
  SupportSection,
  SupportTitle,
  SupportText,
  ContactInfo,
  ContactItem,
} from "./PaymentFailure.styles";
import { useCart } from "../../store/CartContext";
import { useEffect } from "react";

export default function PaymentFailure() {
  const [searchParams] = useSearchParams();

  const orderNumber = searchParams.get("order");
  const reason = searchParams.get("reason") || "Nepoznata greška";
  const { clearCart } = useCart();

  useEffect(() => {
    clearCart();
  }, []);

  const getErrorMessage = (reason) => {
    const reasonLower = reason.toLowerCase();

    if (reasonLower.includes("declined") || reasonLower.includes("odbačen")) {
      return "Plaćanje je odbačeno od strane banke. Molimo proverite podatke kartice ili kontaktirajte vašu banku.";
    }
    if (
      reasonLower.includes("insufficient") ||
      reasonLower.includes("nedovoljan")
    ) {
      return "Nedovoljno sredstava na kartici. Molimo koristite drugu karticu ili kontaktirajte vašu banku.";
    }
    if (reasonLower.includes("expired") || reasonLower.includes("istekao")) {
      return "Kartica je istekla. Molimo koristite važeću karticu.";
    }
    if (reasonLower.includes("invalid") || reasonLower.includes("nevažeća")) {
      return "Uneti podaci kartice nisu važeći. Molimo proverite broj kartice, datum isteka i CVV kod.";
    }
    if (reasonLower.includes("timeout") || reasonLower.includes("vreme")) {
      return "Vreme za plaćanje je isteklo. Molimo pokušajte ponovo.";
    }

    return "Došlo je do greške prilikom plaćanja. Molimo pokušajte ponovo ili kontaktirajte podršku.";
  };

  const handleRetryPayment = () => {
    // Redirect back to checkout
    window.location.href = "/checkout";
    window.scrollTo(0, 0);
  };

  const handleBackToStore = () => {
    window.location.href = "/setovi";
    window.scrollTo(0, 0);
  };

  return (
    <PageWrapper>
      <SmallClouds experiences />

      <Container>
        <FailureContainer>
          <FailureIcon>
            <FaTimes />
          </FailureIcon>

          <FailureTitle>Plaćanje neuspešno</FailureTitle>

          {orderNumber && <OrderNumber>Narudžbina #{orderNumber}</OrderNumber>}

          <FailureSubtitle>
            Nažalost, vaše plaćanje nije moglo biti obrađeno.
          </FailureSubtitle>

          <ErrorMessage>
            <FaExclamationTriangle />
            {getErrorMessage(reason)}
          </ErrorMessage>

          <InfoGrid>
            <InfoBox>
              <InfoHeader>
                <FaRedo />
                <InfoTitle>Pokušajte ponovo</InfoTitle>
              </InfoHeader>
              <InfoText>
                Molimo proverite podatke kartice i pokušajte ponovo sa plaćanjem
              </InfoText>
            </InfoBox>

            <InfoBox>
              <InfoHeader>
                <FaPhone />
                <InfoTitle>Kontaktirajte banku</InfoTitle>
              </InfoHeader>
              <InfoText>
                Ako se problem nastavi, kontaktirajte vašu banku za dodatne
                informacije
              </InfoText>
            </InfoBox>
          </InfoGrid>

          <ButtonGroup>
            <RetryButton onClick={handleRetryPayment}>
              <FaRedo />
              Pokušaj ponovo
            </RetryButton>

            <BackButton onClick={handleBackToStore}>
              <FaArrowLeft />
              Nazad na setove
            </BackButton>
          </ButtonGroup>

          <SupportSection>
            <SupportTitle>Potrebna vam je pomoć?</SupportTitle>
            <SupportText>
              Naš tim za podršku je dostupan da vam pomogne sa bilo kojim
              pitanjima.
            </SupportText>

            <ContactInfo>
              <ContactItem>
                <FaEnvelope />
                <span>info@receptizaroditeljstvo.rs</span>
              </ContactItem>
              <ContactItem>
                <FaPhone />
                <span>+381 69 821 06 20</span>
              </ContactItem>
              <ContactItem>
                <FaPhone />
                <span>+381 63 151 99 31</span>
              </ContactItem>
            </ContactInfo>
          </SupportSection>
        </FailureContainer>
      </Container>
    </PageWrapper>
  );
}
